export default __webpack_public_path__ + "static/media/boombox.6bdb46c1.png";